import { HttpClient } from '@angular/common/http'
import { inject, Injectable } from '@angular/core'
import { environment } from 'src/environments/environment'
import { map } from 'rxjs'
import { ApiResponse } from 'src/app/shared/interfaces/api-response/api-response.interface'
import { EngineerTrackingResponse } from '../interfaces/engineer-tracking-response.interface'

@Injectable({
    providedIn: 'root',
})
export class EngineerTrackingService {
    #httpClient = inject(HttpClient)

    getEngineerTracking(id: string) {
        return this.#httpClient
            .get<ApiResponse<EngineerTrackingResponse>>(`${environment.baseUrl}public/engineertracking/${id}`)
            .pipe(map((x) => x.result))
    }
}
